<div class="d-none d-wdgt-inline" *ngIf="filteredTableData">
    <table>
        <thead>
            <tr>
                <th *ngFor="let colName of headerColumns; let i = index">
                    <div class="d-flex">
                        <div>{{ colName | translate | edpCapitalize }}</div>
                        <div *ngIf="i === 0" class="arrow-content">
                            <span (click)="orderByDate(false)" class="arrow-up cursor-pointer"></span>
                            <span (click)="orderByDate(true)" class="arrow-down cursor-pointer"></span>
                        </div>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of filteredTableData; let i = index">
                <td *ngIf="data.col1">
                    <div [ngClass]="{ lighter: data.col1.light }">
                        {{ service.setDates(data.col1.data, data.col1.day) | edpCapitalize }}
                    </div>
                </td>
                <td *ngIf="data.col2">
                    <ng-container [ngSwitch]="data.col2.colType">
                        <div [ngClass]="{ lighter: data.col2.light }" *ngSwitchCase="2">
                            {{ service.longDescriptionFormat(data.col2.data) }}
                        </div>
                        <div [ngClass]="{ lighter: data.col2.light }" *ngSwitchCase="3">
                            {{ service.setDates(data.col2.data, data.col2.day) | edpCapitalize }}
                        </div>
                    </ng-container>
                </td>
                <td *ngIf="data.col3">
                    <ng-container [ngSwitch]="data.col3.colType">
                        <div [ngClass]="{ lighter: data.col3.light }" *ngSwitchCase="1">
                            {{ data.col3.data | translate }}
                        </div>
                        <div [ngClass]="{ lighter: data.col3.light }" *ngSwitchCase="2">
                            {{ data.col3.data }}
                        </div>
                        <div [ngClass]="{ lighter: data.col3.light }" *ngSwitchCase="3">
                            {{ service.setDates(data.col3.data, data.col3.day) | titlecase }}
                        </div>
                    </ng-container>
                </td>

                <td *ngIf="data.col4">
                    <div [ngClass]="{ lighter: data.col4.light }" *ngIf="data.col4.abs">
                        {{ data.col4.data }}
                    </div>
                    <div [ngClass]="{ lighter: data.col4.light }" *ngIf="!data.col4.abs">
                        {{ data.col4.data }}
                    </div>
                </td>

                <td *ngIf="data.col5">
                    <div class="col-5-wrapper">
                        <div [ngClass]="{ lighter: data.col5.light }" *ngIf="!data.col5.isCard">
                            {{ data.col5.data }}
                        </div>
                        <div [ngClass]="{ lighter: data.col5.light }" *ngIf="data.col5.isCard">
                            <span
                                class="card-status"
                                [ngClass]="{
                                    'status-payed': data.col5.cardDataType === 'P',
                                    'status-awaiting': data.col5.cardDataType === 'NP',
                                    'status-credit': data.col5.cardDataType === 'C'
                                }"
                            >
                                {{ data.col5.cardDataAcro | translate | truncate: 11 | edpCapitalize }}
                            </span>
                        </div>
                        <div *ngIf="data.col5.isDebit">
                            <ng-template #popoverTemplate>
                                <edp-popover #popComponent [popoverContent]="popoverContent" [popBtn]="'icon icon-edponline-Bop-025'">
                                    <ng-template #popoverContent>
                                        <span class="d-block tooltip-text">
                                            {{ "pt.edp.edponline.table.v2.col5.popover" | translate }}
                                        </span>
                                    </ng-template>
                                </edp-popover>
                            </ng-template>
                            <ng-container *ngTemplateOutlet="popoverTemplate"></ng-container>
                        </div>
                    </div>
                </td>

                <td>
                    <i
                        *ngIf="data.col6.available; else unavailable"
                        class="icon-edponline-Bop-140 download-icon"
                        (click)="downloadItem(data.col6.link)"
                    ></i>
                    <ng-template #unavailable>
                        <span class="download-unavailable">{{ data.col6.unavailableLabel | translate }}</span>
                    </ng-template>
                </td>
            </tr>
        </tbody>
    </table>

    <div class="block-pagination row d-none d-md-block" *ngIf="total > pageSize">
        <div class="col-12">
            <div class="d-flex align-items-center">
                <div class="d-flex flex-fill justify-content-center">
                    <ngb-pagination
                        [collectionSize]="total"
                        [(page)]="page"
                        [pageSize]="pageSize"
                        (pageChange)="changePage($event, pageSize)"
                    ></ngb-pagination>
                </div>
            </div>
        </div>
    </div>
</div>
